import React, { useEffect } from "react";
import { Form, DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";

function Date({
  form,
  name,
  label,
  width,
  controlHeight,
  required,
  errorMessage,
  validateFunction,
  defaultValue,
  placeholder,
  disabled,
  showTime,
  labelCol,
  format,
  isIST,
  bg = '#ffffff'
}) {
  // let myMomentObject;
  // // console.log("et"+defaultValue)
  // // console.log("ERT"+ moment(defaultValue).format('YYYY/MM/DD'))
  // if (defaultValue) {
  //   //  myMomentObject = moment(defaultValue, 'YYYY-MM-DD')
  //   myMomentObject = moment(defaultValue).format("YYYY/MM/DD");
  //   myMomentObject = moment(myMomentObject, "YYYY/MM/DD");
  //   // myMomentObject = moment(defaultValue).format("YYYY/MM/DD").toString();
  // }
  // console.log(moment(defaultValue["$date"]).format("YYYY-MM-DD HH:mm:ss"));
  // console.log(myMomentObject); 

  useEffect(() => {
    if(defaultValue && form){
      form.setFieldsValue({ [name]: dayjs(defaultValue)})
    }
  }, []);

  return (
    <Form.Item
      name={name}
      label={label}
      labelCol={{span: labelCol ? labelCol : 8}}
      // initialValue={value}
      // initialValue={(defaultValue && !form) ? dayjs(defaultValue) : null}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        () => ({
          validator(rule, value) {
            return validateFunction
              ? validateFunction(rule, value)
              : Promise.resolve();
          },
        }),
      ]}
    >
      <DatePicker
        
        showTime={showTime}
        allowClear={false}
        showToday
        format={format}
        disabled={disabled}
        use12Hours={isIST ? isIST : false}
        style={{
          // marginRight: "12px",
          fontWeight: 600,
          backgroundColor: bg,
          minHeight: controlHeight || 40
        }}
        placeholder={placeholder}
      />
    </Form.Item>
  );
}

export default Date;
